import { render, staticRenderFns } from "./ArmscorCeoForADay.vue?vue&type=template&id=b6bb46c6&scoped=true&"
import script from "./ArmscorCeoForADay.vue?vue&type=script&lang=js&"
export * from "./ArmscorCeoForADay.vue?vue&type=script&lang=js&"
import style0 from "./ArmscorCeoForADay.vue?vue&type=style&index=0&id=b6bb46c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb46c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VRow,VSimpleTable})
